import { ChatbotConfigurationInterface } from '../interfaces';
import { ApiChatbotRequestInterface } from '../interfaces/api';

export const mapFaqAnswerRequest = (
    configuration: ChatbotConfigurationInterface,
    sessionId?: string
): Partial<ApiChatbotRequestInterface> => ({
    customerKey: configuration.customerKey,
    projectKey: configuration.projectKey,
    apiKey: configuration.apiKey,
    classificationId: 1,
    culture: configuration.culture,
    ...(sessionId && { 'session.id': sessionId })
});
